<template>
    <div :class="{ 'edit-mode': editing, 'read-mode': !editing }">
        <div class='header-container mt-3 mb-3'>
            <div class="d-flex align-center">
                <v-card outlined class='w-auto'>
                    <div class='w-auto d-flex flex-row align-center pa-2'>
                        <v-select
                            dense
                            v-model='filterEquipment'
                            :items='filterOptions.equipments'
                            :label="$t('plod-entry.equipment')"
                            outlined
                            hide-details
                            item-text='value'
                            class='filter-options mr-2'
                            return-object
                            multiple
                            chips
                            clearable
                        >
                            <template v-slot:selection="{ item, index }">
                                <span v-if="filterEquipment.length === 1 && index === 0" class="v-select__selection v-select__selection--comma">{{ item.value }}</span>
                                <span
                                    v-else-if="index === 0"
                                >
                              {{ filterEquipment.length }} pieces
                            </span>
                            </template>
                        </v-select>
                        <v-select
                            dense
                            v-model='filterLocation'
                            :items='filterOptions.locations'
                            :label="$termSync('Location')"
                            outlined
                            hide-details
                            item-text='value'
                            class='filter-options mr-2'
                            return-object
                            multiple
                            chips
                            clearable
                        >
                            <template v-slot:selection="{ item, index }">
                                <span v-if="filterLocation.length === 1 && index === 0" class="v-select__selection v-select__selection--comma">{{ item.value }}</span>
                                <span
                                    v-else-if="index === 0"
                                >
                              {{ filterLocation.length }} locations
                            </span>
                            </template>
                        </v-select>
                        <v-select
                            dense
                            v-model='filterTaskType'
                            :items='filterOptions.taskTypes'
                            :label="$t('plod-entry.task-type')"
                            outlined
                            hide-details
                            item-text='value'
                            class='filter-options mr-2'
                            return-object
                            multiple
                            chips
                            clearable
                        >
                            <template v-slot:selection="{ item, index }">
                                <span v-if="filterTaskType.length === 1 && index === 0" class="v-select__selection v-select__selection--comma">{{ item.value }}</span>
                                <span
                                    v-else-if="index === 0"
                                >
                              {{ filterTaskType.length }} tasks
                            </span>
                            </template>
                        </v-select>
                        <v-select
                            dense
                            v-model='filterOperator'
                            :items='filterOptions.operators'
                            :label="$t('plod-entry.operator')"
                            outlined
                            hide-details
                            item-text='value'
                            class='filter-options mr-2'
                            return-object
                            multiple
                            chips
                            clearable
                        >
                            <template v-slot:selection="{ item, index }">
                                <span v-if="filterOperator.length === 1 && index === 0" class="v-select__selection v-select__selection--comma">{{ item.value }}</span>
                                <span
                                    v-else-if="index === 0"
                                >
                              {{ filterOperator.length }} staff
                            </span>
                            </template>
                        </v-select>
                        <v-btn class='filter-button mr-2'
                               outlined
                               @click='loadData(true)'
                               color='primary'>
                            <span v-if='!filterRefresh'>{{ $t('shared.label.filter') }}</span>
                            <v-progress-circular v-else indeterminate :size='20' />
                        </v-btn>
                        <v-btn
                            outlined
                            class='clear-filter '
                            @click='clearFilter()'
                            color='primary'>
                            <v-icon class='pa-0 ma-0'>mdi-close</v-icon>
                        </v-btn>
                    </div>
                </v-card>
                <v-tooltip bottom>
                    <template v-slot:activator='{ on }'>
                        <v-btn
                            class='ml-4 d-none d-lg-inline-block'
                            outlined
                            @click='openOperatorCompletion()'
                            v-on="on"
                            color='primary'>
                            {{ $t('plod-entry.plods') }}
                            <v-icon right>mdi-list-status</v-icon>
                        </v-btn>
                        <v-btn
                            class='ml-4 d-lg-none'
                            outlined
                            icon
                            @click='openOperatorCompletion()'
                            v-on="on"
                            color='primary'>
                            <v-icon>mdi-list-status</v-icon>
                        </v-btn>
                    </template>
                    <span>
                    {{ $t('plod-entry.view-operator-plod-completion-information') }}
                  </span>
                </v-tooltip>
                <v-tooltip v-if="potentialDuplicatesCount > 0" bottom>
                    <template v-slot:activator='{ on }'>
                        <v-badge
                            :content="potentialDuplicatesCount"
                            color="red"
                            overlap
                        >
                            <v-btn
                                class='ml-4 d-none d-lg-inline-block'
                                outlined
                                @click='toggleDuplicatesView'
                                v-on="on"
                                color='primary'>
                                {{ $t('plod-entry.duplicates') }}
                                <v-icon right>mdi-text-box-multiple-outline</v-icon>
                            </v-btn>
                            <v-btn
                                class='ml-4 d-lg-none'
                                outlined
                                icon
                                @click='toggleDuplicatesView'
                                v-on="on"
                                color='primary'>
                                <v-icon>mdi-text-box-multiple-outline</v-icon>
                            </v-btn>
                        </v-badge>

                    </template>
                    <span>
                    {{ $t('plod-entry.view-potential-duplicates') }}
                  </span>
                </v-tooltip>

            </div>
            <div class='d-flex flex-row'>
                <v-switch
                    v-model='showDelays'
                    :label="$t('plod-entry.show-delays')"
                    dense
                    hide-details
                    class='my-0 mr-2'
                    key="showDelaysSwitch"
                ></v-switch>
                <v-chip
                    v-if='editing && pageStatus'
                    class='status-chips mr-2'
                    outlined
                    :color="pageStatus === 'Saved' ? 'green' : 'orange'"
                    key="pageStatusChip"
                >
                    {{ pageStatus }}
                </v-chip>
                <v-tooltip v-if='displaySyncTimesButton' bottom>
                    <template v-slot:activator='{ on }'>
                        <v-btn
                            :disabled='saving'
                            @click='syncTimes'
                            color='primary'
                            outlined
                            class='ml-2 '
                            v-on="on"
                        >
                            {{ $t('plod-entry.sync-times') }}
                        </v-btn>
                    </template>
                    <span>
                    {{ $t('plod-entry.pull-start-and-end-times') }}
                  </span>
                </v-tooltip>

                <v-btn
                    v-if='editing'
                    :disabled='saving'
                    @click='addRow()'
                    color='primary'
                    outlined
                    class='ml-2 '>
                    {{ $t('plod-entry.add-plod-entry') }}
                </v-btn>
                <v-btn
                    v-if='areReportable'
                    @click='cancelReportability'
                    color='primary'
                    class='ml-2 '
                    key="markNotReportableButton"
                >
                    {{ $t('plod-entry.undo-completion') }}
                </v-btn>
                <v-btn
                    v-if='!areReportable'
                    @click='markReportable'
                    color='primary'
                    class='ml-2 '
                    key="markReportableButton"
                >
                    {{ $t('shared.button.complete') }}
                </v-btn>
            </div>
        </div>
        <v-banner single-line v-if="notDoneTasksCount > 0" icon="mdi-alert" color="warning">
            {{ notDoneTasksCount }} {{ 'task' | term(notDoneTasksCount) }} {{ notDoneTasksCount | pluralize('is', 'are') }} marked as not started.
            <template v-slot:actions>
                <v-btn text color="white" @click="() => tasksNotDoneDialog=true">{{ $t('plod-entry.show-term', { term: $pluralSync('task', notDoneTasksCount) }) }}</v-btn>
            </template>
        </v-banner>

        <div v-if='dataLoaded && formData.actualsRows.length === 0'
             class='grey lighten-4 pa-5 text-center'>
            {{ $t('plod-entry.no-actuals-data-found') }}
            <div class='mt-5' v-if='editing && !filtersActive'>
                <v-btn
                    @click='populateShiftData()'
                    color='primary'
                    style='text-align: center'>
                    {{ $t('plod-entry.populate-data-for-shift') }}
                </v-btn>
            </div>
        </div>

        <div v-if='!dataLoaded' class='grey lighten-4 pa-5 text-center'>
            <v-progress-circular
                indeterminate
                color='primary'
            ></v-progress-circular>
        </div>

        <div v-if='dataLoaded && formData.actualsRows.length > 0' class='table_wrapper'>
            <v-data-table
                :items='filteredAndGroupedActuals'
                :hide-default-footer='true'
                class='custom-plod-table'
                hide-default-header
                :disable-pagination='true'
                :key='tableKey'
                :loading='!dataLoaded'
            >
                <!-- Dynamically generating the headers -->
                <template v-slot:header>
                    <thead>
                    <tr class='header-s'>
                        <th rowspan='2' class='icon-column header'>
                            <v-menu v-model="multiSortMenu" offset-y :close-on-content-click="false" @input="onMultiSortMenuChange">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-bind="attrs" v-on="on" icon small :title="'Multi-sort'">
                                        <v-icon>mdi-sort</v-icon>
                                    </v-btn>
                                </template>
                                <v-card class="pa-3" width="340">
                                    <div class="subtitle-2 mb-2">{{ $t('plod-entry.sort-by-up-to-3-columns') }}</div>
                                    <div v-for="(crit, idx) in multiSortWorking" :key="'ms-'+idx" class="d-flex align-center mb-3 multi-sort-row">
                                        <v-select
                                            class="mr-2 multi-sort-select"
                                            hide-details
                                            :items="multiSortableFields"
                                            item-text="text"
                                            item-value="value"
                                            :label="$t('plod-entry.column')"
                                            v-model="crit.field"
                                            :menu-props="{ contentClass: 'multi-sort-select-menu' }"
                                            :disabled="false"
                                        />
                                        <v-select
                                            class="multi-sort-select"
                                            hide-details
                                            :items="sortDirections"
                                            item-text="text"
                                            item-value="value"
                                            :label="$t('plod-entry.direction')"
                                            v-model="crit.direction"
                                            :menu-props="{ contentClass: 'multi-sort-select-menu' }"
                                        />
                                        <v-btn icon small class="ml-1" :title="'Remove'" v-if="idx !== 0" @click="removeMultiSortWorking(idx)"><v-icon small>mdi-close</v-icon></v-btn>
                                    </div>
                                    <v-card-actions>
                                        <v-btn small text :disabled="multiSortWorking.length >= 3 || multiSortWorking.length >= multiSortableFields.length" @click="addMultiSortLevelWorking">{{ $t('plod-entry.add-level') }}</v-btn>
                                        <v-spacer></v-spacer>
                                        <v-btn small text @click="cancelMultiSort">{{ $t('shared.button.cancel') }}</v-btn>
                                        <v-btn small color="primary" @click="applyMultiSort">{{ $t('plod-entry.apply') }}</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-menu>
                        </th>
                        <th rowspan='2' class='icon-column header'></th>
                        <th rowspan='2' class='extra-wide header'>
                            <div class='sortable-field' @click="changeSorting(CONSTANTS.FIELDS.LOCATION)">
                                <v-icon :color="editing ? 'white' : 'black'" v-if='activeFilteredLocation'>mdi-filter
                                </v-icon>
                                {{ $termSync('Location') }}
                                <v-icon :color="editing ? 'white' : 'black'" v-if="isFieldSorted(CONSTANTS.FIELDS.LOCATION)">
                                    mdi-arrow-{{ fieldSortDirection(CONSTANTS.FIELDS.LOCATION) }}
                                </v-icon>
                            </div>
                        </th>
                        <th rowspan='2' class='extra-wide header' v-if="displayBlastPacketsAndRings">
                            <div>
                                {{ $termSync('Blast Packet') }}
                            </div>
                        </th>
                        <th rowspan='2' class='extra-wide header' v-if="displayBlastPacketsAndRings">
                            <div>
                                {{ $termSync('Ring') }}
                            </div>
                        </th>
                        <th rowspan='2' class='extra-wide header'>
                            <div class='sortable-field' @click="changeSorting(CONSTANTS.FIELDS.TASK_TYPE)">
                                <v-icon :color="editing ? 'white' : 'black'" v-if='activeFilteredTaskType'>mdi-filter
                                </v-icon>
                                {{ $t('plod-entry.task-type-column') }}
                                <v-icon :color="editing ? 'white' : 'black'" v-if="isFieldSorted(CONSTANTS.FIELDS.TASK_TYPE)">
                                    mdi-arrow-{{ fieldSortDirection(CONSTANTS.FIELDS.TASK_TYPE) }}
                                </v-icon>
                            </div>
                        </th>
                        <th rowspan='2' class='extra-wide header'>
                            <div class='sortable-field' @click="changeSorting(CONSTANTS.FIELDS.EQUIPMENT)">
                                <v-icon :color="editing ? 'white' : 'black'" v-if='activeFilteredEquipment'>mdi-filter
                                </v-icon>
                                {{ 'Equipment' | termPlural }}
                                <v-icon :color="editing ? 'white' : 'black'" v-if="isFieldSorted(CONSTANTS.FIELDS.EQUIPMENT)">
                                    mdi-arrow-{{ fieldSortDirection(CONSTANTS.FIELDS.EQUIPMENT) }}
                                </v-icon>
                            </div>
                        </th>
                        <th rowspan='2' class='extra-wide header'>
                            <div class='sortable-field' @click="changeSorting(CONSTANTS.FIELDS.OPERATOR)">
                                <v-icon :color="editing ? 'white' : 'black'" v-if='activeFilteredOperator'>mdi-filter
                                </v-icon>
                                {{ $t('plod-entry.operator') }}
                                <v-icon :color="editing ? 'white' : 'black'" v-if="isFieldSorted(CONSTANTS.FIELDS.OPERATOR)">
                                    mdi-arrow-{{ fieldSortDirection(CONSTANTS.FIELDS.OPERATOR) }}
                                </v-icon>
                            </div>
                        </th>
                        <th rowspan='2' class='header extra-wide'>
                            {{ $t('plod-entry.cut-number') }}
                        </th>
                        <th rowspan='2' class='header extra-wide'>
                            {{ $t('plod-entry.start-chainage-m') }}
                        </th>
                        <th rowspan='2' class='header extra-wide'>
                            {{ $t('plod-entry.end-chainage-m') }}
                        </th>
                        <th rowspan='2' class='extra-wide'>{{ $t('shared.label.comments') }}</th>
                        <th rowspan='2' class='col-time'>{{ $t('plod-entry.start-time') }}</th>
                        <th rowspan='2' class='col-time'>{{ $t('plod-entry.end-time') }}</th>
                        <th rowspan='2'>
                            <v-tooltip bottom>
                                <template v-slot:activator='{ on, attrs }'>
                                    <span
                                        v-bind='attrs'
                                        v-on='on'>
                                        {{ $t('plod-entry.complete') }}
                                      </span>
                                </template>
                                <span>
                                {{ $t('plod-entry.percentage-of-task-completed') }}
                              </span>
                            </v-tooltip>
                        </th>
                        <th v-if='editing' rowspan='2' class='ignore-actuals-column'>{{ $t('plod-entry.ignore') }}</th>
                        <th class='group-name' v-for='headerGroup in nonArchivedGroups' :key='headerGroup.groupId'
                            :colspan='headerGroup.definitions.length'>
                            {{ headerGroup.groupName }}
                        </th>
                    </tr>
                    <tr class='header-s'>
                        <template v-for='headerGroup in nonArchivedGroups'>
                            <th v-for='headerGroupItem in headerGroup.definitions' class='subheader'
                                :class='`col-${headerGroupItem.definitionType.toLowerCase()}`'
                                :key='`${headerGroup.groupId}-${headerGroupItem.id}`'>
                                {{ headerGroupItem.definitionName }}
                                <div
                                    v-if="headerGroupItem.definitionType === 'Formula' && headerGroupItem.formula">
                                    <v-tooltip bottom>
                                        <template v-slot:activator='{ on, attrs }'>
                    <span
                        v-bind='attrs'
                        v-on='on' class='formula-indicator'
                    >{{ $t('plod-entry.formula') }}</span>
                                        </template>
                                        <span>
                    {{ headerGroupItem.formulaDescription }}
                  </span>
                                    </v-tooltip>
                                </div>
                            </th>
                        </template>
                    </tr>
                    </thead>
                </template>

                <!-- Body of the table -->
                <template v-slot:body='{ items }'>
                    <tbody class='tbody'>
                    <template v-for='item in items'>
                        <tr :key='`${item.id}`' :class="{'grouped-row-child': item.hierarchyType === CONSTANTS.ROW_HIERARCHY.CHILD && displayParentRows }">
                            <td>
                                <v-tooltip bottom
                                           v-if="item.hierarchyType === CONSTANTS.ROW_HIERARCHY.CHILD && (item.status === CONSTANTS.STATUS.ERROR || (!item.taskTypeId && (!item.taskType || !item.taskType.id)))">
                                    <template v-slot:activator='{ on, attrs }'>
                                        <v-icon color='warning'
                                                v-bind='attrs'
                                                v-on='on'>mdi-alert-circle
                                        </v-icon>
                                    </template>
                                    <span>{{ item.validationError || $t('plod-entry.row-will-not-save-until-task-type') }}</span>
                                </v-tooltip>
                                <v-tooltip bottom
                                           v-if="item.hierarchyType === CONSTANTS.ROW_HIERARCHY.INDIV && (item.status === CONSTANTS.STATUS.ERROR && item.validationError || (!item.taskTypeId && (!item.taskType || !item.taskType.id)))">
                                    <template v-slot:activator='{ on, attrs }'>
                                        <v-icon color='warning'
                                                v-bind='attrs'
                                                v-on='on'>mdi-alert-circle
                                        </v-icon>
                                    </template>
                                    <span>{{ item.validationError || $t('plod-entry.row-will-not-save-until-task-type') }}</span>
                                </v-tooltip>
                                <v-tooltip bottom
                                           v-if="item.hierarchyType === CONSTANTS.ROW_HIERARCHY.PARENT && item.status === CONSTANTS.STATUS.ERROR && item.validationError">
                                    <template v-slot:activator='{ on, attrs }'>
                                        <v-icon color='warning'
                                                v-bind='attrs'
                                                v-on='on'>mdi-alert-circle
                                        </v-icon>
                                    </template>
                                    <span>{{ item.validationError }}</span>
                                </v-tooltip>
                                <v-tooltip bottom
                                           v-if="item.hierarchyType === CONSTANTS.ROW_HIERARCHY.PARENT && !item.validationError">
                                    <template v-slot:activator='{ on, attrs }'>
                                        <v-icon color='grey'
                                                v-bind='attrs'
                                                v-on='on'>mdi-information-outline
                                        </v-icon>
                                    </template>
                                    <span>{{ $t('plod-entry.represents-actuals-same-piece-of-work') }}</span>
                                </v-tooltip>
                                <v-tooltip bottom
                                           v-if="item.hierarchyType !== CONSTANTS.ROW_HIERARCHY.PARENT && item.dataSource === DataAppSource.OrdoConnect">
                                    <template v-slot:activator='{ on, attrs }'>
                                        <v-icon color='secondary'
                                                v-bind='attrs'
                                                v-on='on'>mdi-cellphone-message
                                        </v-icon>
                                    </template>
                                    <span>{{ $t('plod-entry.reported-from-ordo-connect') }}</span>
                                </v-tooltip>

                            </td>
                            <td>
                                <div v-if="editing" class="d-flex flex-column justify-center">
                                    <v-btn icon color='red' @click='deleteActuals(item)' v-if="item.hierarchyType !== CONSTANTS.ROW_HIERARCHY.PARENT">
                                        <v-icon>mdi-delete</v-icon>
                                    </v-btn>
                                    <v-tooltip bottom
                                               v-if="item.hierarchyType === CONSTANTS.ROW_HIERARCHY.PARENT">
                                        <template v-slot:activator='{ on }'>
                                            <v-btn icon color="primary" @click='addChildRow(item)' v-on="on" >
                                                <v-icon>mdi-plus</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>{{ $t('plod-entry.add-plod-entry-for-piece-of-work') }}</span>
                                    </v-tooltip>
                                </div>
                            </td>
                            <td>
                                <v-combobox
                                    v-if="!displayParentRows || (item.hierarchyType !== CONSTANTS.ROW_HIERARCHY.CHILD && groupedFields.includes(CONSTANTS.FIELDS.LOCATION))"
                                    v-model='item.location'
                                    dense
                                    outlined
                                    :items='locationList'
                                    hide-details
                                    class='small-input fixed-width-combo'
                                    item-text='name'
                                    item-value='id'
                                    :return-object='true'
                                    height="30"
                                    :readonly='disableInputs || (Array.isArray(filterLocation) && filterLocation.length === 1)'
                                    @input="handleInputChange(item, null, null, CONSTANTS.FIELDS.LOCATION)"
                                ></v-combobox>
                                <v-text-field
                                    v-if='(!displayParentRows || (item.hierarchyType !== CONSTANTS.ROW_HIERARCHY.CHILD && groupedFields.includes(CONSTANTS.FIELDS.LOCATION))) && item.locationDisplayName'
                                    class='small-input mt-3 fixed-width-combo'
                                    v-model='item.locationDisplayName'
                                    hide-details
                                    :label="$t('plod-entry.display-name')"
                                    outlined
                                    persistent-placeholder
                                    dense
                                    readonly
                                ></v-text-field>
                            </td>
                            <td v-if="displayBlastPacketsAndRings">
                                <v-select
                                    v-if="!displayParentRows || (item.hierarchyType !== CONSTANTS.ROW_HIERARCHY.CHILD && groupedFields.includes(CONSTANTS.FIELDS.BLAST_PACKET))"
                                    v-model='item.blastPacket'
                                    dense
                                    outlined
                                    :items='getPermittedBlastPacketsForLocation(item.location)'
                                    clearable
                                    hide-details
                                    class='small-input fixed-width-combo'
                                    item-text='name'
                                    item-value='id'
                                    :return-object='true'
                                    :readonly='disableInputs'
                                    @input="handleInputChange(item, null, null, CONSTANTS.FIELDS.BLAST_PACKET)"
                                >
                                </v-select>
                            </td>
                            <td v-if="displayBlastPacketsAndRings">
                                <v-select
                                    v-if="!displayParentRows || (item.hierarchyType !== CONSTANTS.ROW_HIERARCHY.CHILD && groupedFields.includes(CONSTANTS.FIELDS.RING))"
                                    v-model='item.ring'
                                    dense
                                    outlined
                                    :items='getPermittedRingsForLocation(item.location, item.blastPacket)'
                                    clearable
                                    hide-details
                                    class='small-input fixed-width-combo'
                                    item-text='name'
                                    item-value='id'
                                    :return-object='true'
                                    :readonly='disableInputs'
                                    @input="handleInputChange(item, null, null, CONSTANTS.FIELDS.RING)"
                                >
                                </v-select>
                            </td>
                            <td>
                                <v-select
                                    v-if="!displayParentRows || (item.hierarchyType !== CONSTANTS.ROW_HIERARCHY.CHILD && groupedFields.includes(CONSTANTS.FIELDS.TASK_TYPE))"
                                    v-model='item.taskType'
                                    dense
                                    outlined
                                    :items='permittedTaskTypeList'
                                    hide-details
                                    class='small-input fixed-width-combo'
                                    item-text='name'
                                    item-value='id'
                                    :return-object='true'
                                    :readonly='disableInputs || !!filterTaskType.key || !item.isCustom'
                                    @input="handleInputChange(item, null, null, CONSTANTS.FIELDS.TASK_TYPE)"
                                >
                                    <template v-if='!item.isCustom && editing' v-slot:append>
                                        <v-icon class='lock-icon'>mdi-lock</v-icon>
                                    </template>
                                </v-select>
                                <v-text-field
                                    v-if='(!displayParentRows || (item.hierarchyType !== CONSTANTS.ROW_HIERARCHY.CHILD && groupedFields.includes(CONSTANTS.FIELDS.TASK_TYPE))) && item.taskTypeDisplayName'
                                    class='small-input mt-3 fixed-width-combo'
                                    v-model='item.taskTypeDisplayName'
                                    hide-details
                                    :label="$t('plod-entry.display-name')"
                                    outlined
                                    persistent-placeholder
                                    dense
                                    readonly
                                ></v-text-field>
                            </td>
                            <td>
                                <v-select
                                    v-if="!displayParentRows || (item.hierarchyType !== CONSTANTS.ROW_HIERARCHY.PARENT && !groupedFields.includes(CONSTANTS.FIELDS.EQUIPMENT)) || (item.hierarchyType !== CONSTANTS.ROW_HIERARCHY.CHILD && groupedFields.includes(CONSTANTS.FIELDS.EQUIPMENT))"
                                    v-model='item.equipment'
                                    dense
                                    outlined
                                    :items='equipmentList'
                                    hide-details
                                    class='small-input fixed-width-combo'
                                    item-text='name'
                                    item-value='id'
                                    :return-object='true'
                                    :readonly='disableInputs || !!filterEquipment.key'
                                    @input="handleInputChange(item, null, null, CONSTANTS.FIELDS.EQUIPMENT)"
                                ></v-select>
                            </td>
                            <td>
                                <v-select
                                    v-if="!displayParentRows || (item.hierarchyType !== CONSTANTS.ROW_HIERARCHY.PARENT && !groupedFields.includes(CONSTANTS.FIELDS.OPERATOR)) || (item.hierarchyType !== CONSTANTS.ROW_HIERARCHY.CHILD && groupedFields.includes(CONSTANTS.FIELDS.OPERATOR))"
                                    v-model='item.operator'
                                    dense
                                    outlined
                                    :items='operatorsList'
                                    hide-details
                                    class='small-input fixed-width-combo'
                                    item-text='name'
                                    item-value='id'
                                    :return-object='true'
                                    :readonly='disableInputs || !!filterOperator.key'
                                    @input="handleInputChange(item, null, null, CONSTANTS.FIELDS.OPERATOR)"
                                ></v-select>
                            </td>
                            <td>
                                <v-select
                                    v-if="item.hierarchyType === CONSTANTS.ROW_HIERARCHY.INDIV || item.hierarchyType === CONSTANTS.ROW_HIERARCHY.CHILD"
                                    v-model='item.cutId'
                                    dense
                                    outlined
                                    :items='getCutsForLocation(item.location)'
                                    item-text='text'
                                    item-value='value'
                                    hide-details
                                    class='small-input fixed-width-combo'
                                    :readonly='!editing || uiLocked || item.originatingTaskId != null'
                                    @input="handleInputChange(item, null, null, CONSTANTS.FIELDS.CUT_ID)"
                                ></v-select>
                            </td>
                            <td>
                                <v-text-field
                                    v-if="item.hierarchyType === CONSTANTS.ROW_HIERARCHY.INDIV || item.hierarchyType === CONSTANTS.ROW_HIERARCHY.CHILD"
                                    v-model='item.startChainage'
                                    class='small-input'
                                    hide-details
                                    outlined
                                    dense
                                    :readonly='!editing || uiLocked || (item.originatingTaskId != null && item.cutId != null && item.cutId !== "")'
                                    type='number'
                                    step='0.1'
                                    v-on='{ keypress: (e) => validateInput(e, "Chainage") }'
                                    @input="handleInputChange(item, null, null, CONSTANTS.FIELDS.START_CHAINAGE)"
                                ></v-text-field>
                            </td>
                            <td>
                                <v-text-field
                                    v-if="item.hierarchyType === CONSTANTS.ROW_HIERARCHY.INDIV || item.hierarchyType === CONSTANTS.ROW_HIERARCHY.CHILD"
                                    v-model='item.endChainage'
                                    class='small-input'
                                    hide-details
                                    outlined
                                    dense
                                    :readonly='!editing || uiLocked || (item.originatingTaskId != null && item.cutId != null && item.cutId !== "")'
                                    type='number'
                                    step='0.1'
                                    v-on='{ keypress: (e) => validateInput(e, "Chainage") }'
                                    @input="handleInputChange(item, null, null, CONSTANTS.FIELDS.END_CHAINAGE)"
                                ></v-text-field>
                            </td>
                            <td>
                                <v-textarea
                                    v-if="item.hierarchyType !== CONSTANTS.ROW_HIERARCHY.PARENT"
                                    class='small-input'
                                    v-model='item.comment'
                                    outlined
                                    hide-details
                                    single-line
                                    dense
                                    rows='1'
                                    :placeholder="$t('plod-entry.enter-comments-here')"
                                    :readonly='disableInputs'
                                    @input='handleInputChange(item)'
                                ></v-textarea>
                            </td>
                            <td>
                                <v-text-field
                                    v-if="item.hierarchyType !== CONSTANTS.ROW_HIERARCHY.PARENT"
                                    class='small-input'
                                    v-model='item.startTime'
                                    hide-details
                                    outlined
                                    dense
                                    :readonly='disableInputs'
                                    type='time'
                                    @input='handleInputChange(item)'
                                ></v-text-field>
                            </td>
                            <td>
                                <v-text-field
                                    v-if="item.hierarchyType !== CONSTANTS.ROW_HIERARCHY.PARENT"
                                    class='small-input'
                                    v-model='item.endTime'
                                    hide-details
                                    outlined
                                    dense
                                    :readonly='disableInputs'
                                    type='time'
                                    @input='handleInputChange(item)'
                                ></v-text-field>
                            </td>
                            <td>
                                <v-text-field
                                    v-if="item.hierarchyType !== CONSTANTS.ROW_HIERARCHY.PARENT"
                                    class='small-input'
                                    v-model='item.completionPercent'
                                    hide-details
                                    outlined
                                    dense
                                    :readonly='disableInputs'
                                    type='text'
                                    @input='handleInputChange(item)'
                                    v-on='{ keypress: (e) => validateInput(e, "Percent") }'
                                ></v-text-field>
                            </td>
                            <td>
                                <v-tooltip bottom
                                           v-if="item.hierarchyType !== CONSTANTS.ROW_HIERARCHY.PARENT">
                                    <template v-slot:activator='{ on }'>
                                        <span v-on="on">
                                            <v-checkbox
                                                v-model='item.ignoreValuesForReporting'
                                                class='small-input'
                                                hide-details
                                                dense
                                                :disabled='!editing || uiLocked'
                                                @change='handleInputChange(item, null, null, CONSTANTS.FIELDS.IGNORE_ACTUALS)'
                                            ></v-checkbox>
                                        </span>

                                    </template>
                                    <span>{{ $t('plod-entry.ignore-row-for-reporting') }}</span>
                                </v-tooltip>

                            </td>

                            <template v-for='headerGroup in nonArchivedGroups'>
                                <td v-for='headerGroupItem in headerGroup.definitions'
                                    :key='`${headerGroup.groupId}-${headerGroupItem.id}`'>
                                    <v-text-field
                                        v-if="headerGroupItem.definitionType !== 'Boolean' && !valueSets[headerGroupItem.id] && item.taskType && groupIsRelevantToTaskType(headerGroup, item.taskType.id)"
                                        class='small-input'
                                        v-model="item.actualsPairs[getActualsPairKey(headerGroup.groupId, headerGroupItem.id)]"
                                        hide-details
                                        outlined
                                        dense
                                        :disabled='(item.hierarchyType === CONSTANTS.ROW_HIERARCHY.PARENT && !headerGroupItem.summable) || !item.taskType || !groupIsRelevantToTaskType(headerGroup, item.taskType.id)'
                                        :readonly="item.hierarchyType === CONSTANTS.ROW_HIERARCHY.PARENT || disableInputs || headerGroupItem.definitionType === 'Formula'"
                                        :type='getTextFieldType(headerGroupItem.definitionType)'
                                        v-on='{ keypress: (e) => validateInput(e, headerGroupItem.definitionType) }'
                                        @input='handleInputChange(item, headerGroupItem, headerGroup)'
                                    ></v-text-field>
                                    <v-select
                                        v-if='valueSets[headerGroupItem.id]  && item.taskType && groupIsRelevantToTaskType(headerGroup, item.taskType.id)'
                                        v-model="item.actualsPairs[getActualsPairKey(headerGroup.groupId, headerGroupItem.id)]"
                                        dense
                                        outlined
                                        :disabled='item.hierarchyType === CONSTANTS.ROW_HIERARCHY.PARENT || !item.taskType || !groupIsRelevantToTaskType(headerGroup, item.taskType.id)'
                                        :items='[...valueSets[headerGroupItem.id], item.actualsPairs[getActualsPairKey(headerGroup.groupId, headerGroupItem.id)]]'
                                        hide-details
                                        class='small-input'
                                        :readonly='disableInputs'
                                        @input='handleInputChange(item, headerGroupItem, headerGroup)'
                                    >
                                    </v-select>
                                    <v-checkbox
                                        v-if="headerGroupItem.definitionType === 'Boolean' && item.taskType && groupIsRelevantToTaskType(headerGroup, item.taskType.id)"
                                        v-model="item.actualsPairs[getActualsPairKey(headerGroup.groupId, headerGroupItem.id)]"
                                        class='small-input'
                                        hide-details
                                        :disabled='item.hierarchyType === CONSTANTS.ROW_HIERARCHY.PARENT || !item.taskType || !groupIsRelevantToTaskType(headerGroup, item.taskType.id)'
                                        :readonly='disableInputs'
                                        @change='handleInputChange(item, headerGroupItem, headerGroup)'
                                    ></v-checkbox>
                                </td>
                            </template>
                        </tr>
                    </template>
                    <tr v-if='nonArchivedGroups && nonArchivedGroups.length > 0' class='totals-row'>
                        <td></td>
                        <td></td>
                        <td>
                            <div style='height: 40px; font-weight: bold; align-content: center'>{{ $t('plod-entry.totals') }}</div>
                        </td>
                        <td v-if="displayBlastPacketsAndRings">
                        </td>
                        <td v-if="displayBlastPacketsAndRings">
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <template v-for='headerGroup in nonArchivedGroups'>
                            <td v-for='headerGroupItem in headerGroup.definitions'
                                :key='`${headerGroup.groupId}-${headerGroupItem.id}`'>
                                <v-text-field
                                    :disabled='!headerGroupItem.summable'
                                    v-model='totals[`${headerGroup.groupId}_${headerGroupItem.id}`]'
                                    class='small-input'
                                    hide-details
                                    outlined
                                    dense
                                    readonly
                                >
                                </v-text-field>
                            </td>
                        </template>
                    </tr>

                    </tbody>
                </template>
            </v-data-table>
        </div>
        <standard-dialog
            v-model="tasksNotDoneDialog"
            :title="$t('plod-entry.rejected-tasks')"
            :max-width="1200"
        >
            <template #content>
                <rejected-tasks-sheet :tasks="tasksNotDone" />
            </template>
            <template #actions>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="tasksNotDoneDialog = false">{{ $t('shared.button.close') }}</v-btn>
            </template>
        </standard-dialog>

        <standard-dialog
            v-model="operatorCompletionDialog"
            :title="$t('plod-entry.plod-completion')"
            :max-width="1200"
            :is-loading="$wait.is('loading-operator-completion')"
            loaderName="PlodEntry - Operator Completion"
        >
            <template #content>
                <operator-completion-sheet
                    :operator-completion-information="operatorCompletionInformation"
                    :operators-in-filter="filterOptions.operators.map(o => o.key)"
                    @filter-to-operator="filterToOperator"
                ></operator-completion-sheet>
            </template>
            <template #actions>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="operatorCompletionDialog = false">{{ $t('shared.button.close') }}</v-btn>
            </template>
        </standard-dialog>

        <shift-printer
            :shiftId="shiftId"
            :departmentId="departmentId"
            :departmentName="departmentName"
            :department-features="departmentFeatures"
            :date="$route.params.date"
            :shift="$route.params.shift"
        ></shift-printer>
        <v-slide-y-reverse-transition>
            <v-footer color="primary" fixed v-if="showDuplicatesView" class="white--text">
                <v-spacer></v-spacer>{{ $t('plod-entry.viewing-potential-duplicates-read-only') }}
                <v-btn color="secondary" @click="toggleDuplicatesView" class="ml-3">{{ $t('shared.button.close') }}</v-btn>
                <v-spacer></v-spacer>
            </v-footer>
        </v-slide-y-reverse-transition>
        <confirm ref='confirm'></confirm>

            <Transition name='wobble-in'>

                        <v-btn
                            v-if="lastDeletedPlod"
                            color="primary"
                            dark
                            fab
                            fixed
                            bottom
                            right
                            @click="undoLastDeletedPlod"

                        >
                            <v-tooltip left>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs"
                                            v-on="on">mdi-undo</v-icon>
                                </template>
                                <span>{{ $t('plod-entry.undo-deletion') }}</span>
                            </v-tooltip>
                        </v-btn>

            </Transition>
    </div>
</template>

<script>
import Vue from 'vue';
import Equipment from '@/lib/data/Equipment';
import Actuals from '@/lib/data/Actuals';
import { useSystemStore } from '@/lib/stores/SystemStore';
import _, { update } from 'lodash';
import { mapState } from 'pinia';
import { useShiftDetails } from '@/lib/stores/Shift';
import { v4 as uuidv4 } from 'uuid';
import { DateFormat } from '@/plugins/dates';
import { useDepartmentStore } from '@/lib/stores/DepartmentStore';
import { EventBus, Events } from '@/lib/EventBus';
import Logging from '@/lib/Logging';
import dayjs from 'dayjs';
import { useShiftWindowActuals } from '@/lib/stores/Production/ShiftWindowActualsStore';
import { CycleType, DataAppSource, MiningMethodType } from '@/models/api';
import { RemoveLocationNameFromBlastPacketOrRingName } from '@/lib/services/Production';
import { useBlastPacketsStore } from '@/lib/stores/Production/BlastPacketsStore';
import DailyReports from '@/lib/data/DailyReports';
import ResourceComments from '@/components/ShiftBoard/SubComponents/ResourceComments.vue';
import StandardDialog from '@/components/Shared/Common/StandardDialog.vue';
import ContentLoading from '@/components/Shared/ContentLoading.vue';
import OperatorCompletionSheet from '@/components/Actuals/OperatorCompletionSheet.vue';
import RejectedTasksSheet from '@/components/Actuals/RejectedTasksSheet.vue';

function fallbackComparator(a, b, sortMultiplier) {
    const taskTypeSortValue = taskTypeSortComparator(a, b, sortMultiplier);

    if(taskTypeSortValue === 0)
        return hierarchyAndOriginatingTaskComparator(a, b);

    return taskTypeSortValue;
}

function hierarchyAndOriginatingTaskComparator(a,b) {
    const hierarchySortOrderDiff = getHierarchySortOrder(a) - getHierarchySortOrder(b);

    if(hierarchySortOrderDiff === 0)
        return originatingTaskComparator(a,b);

    return hierarchySortOrderDiff;
}

function originatingTaskComparator(a,b) {
    const valueAOriginatingTaskId = getRowOriginatingTaskIdForSorting(a);
    const valueBOriginatingTaskId = getRowOriginatingTaskIdForSorting(b);

    if(valueAOriginatingTaskId === valueBOriginatingTaskId)
        return getHierarchySortOrder(a) - getHierarchySortOrder(b);

    return valueAOriginatingTaskId.localeCompare(valueBOriginatingTaskId);
}

function equipmentSortComparator(a, b, sortMultiplier, terminatingComparator = false) {
    let valueA = a.equipment?.name ?? '';
    let valueB = b.equipment?.name ?? '';

    return valueA.localeCompare(valueB) * sortMultiplier;
}

function locationSortComparator(a, b, sortMultiplier, terminatingComparator = false) {
    const valueALocation = typeof a.location === 'string' ? a.location : a.location?.name ?? '';
    const valueATaskType = a.taskType?.name ?? '';
    const valueBLocation = typeof b.location === 'string' ? b.location : b.location?.name ?? '';
    const valueBTaskType = b.taskType?.name ?? '';

    if (valueALocation === valueBLocation) {
        if(!terminatingComparator)
            return 0;

        if (valueATaskType === valueBTaskType)
            return hierarchyAndOriginatingTaskComparator(a, b);

        return valueATaskType.localeCompare(valueBTaskType) * sortMultiplier;
    }

    return valueALocation.localeCompare(valueBLocation) * sortMultiplier;
}

function taskTypeSortComparator(a, b, sortMultiplier, terminatingComparator = false) {
    let valueA = a.taskType?.name ?? '';
    let valueB = b.taskType?.name ?? '';


    if (valueA === valueB)
        return terminatingComparator ? hierarchyAndOriginatingTaskComparator(a, b) : 0;

    return valueA.localeCompare(valueB) * sortMultiplier;
}

function operatorSortComparator(a, b, sortMultiplier, terminatingComparator = false) {
    let valueA = a.operator?.name ?? '';
    let valueB = b.operator?.name ?? '';

    return valueA.localeCompare(valueB) * sortMultiplier;
}

function groupIsRelevantToTaskType(group, taskTypeId) {
    return group.taskTypes.some(tt => tt.taskTypeId === taskTypeId);
}

function definitionCanBeSummed(definition) {
    return definition.summable && (definition.definitionType === 'Decimal' || definition.definitionType === 'Integer' || definition.definitionType === 'Formula');
}

function getHierarchySortOrder(row) {
    if (row.hierarchyType === CONSTANTS.ROW_HIERARCHY.PARENT) {
        return 0;
    } else if (row.hierarchyType === CONSTANTS.ROW_HIERARCHY.CHILD) {
        return 1;
    } else if (row.hierarchyType === CONSTANTS.ROW_HIERARCHY.INDIV) {
        return 2;
    }
    return 3;
}

function getRowOriginatingTaskIdForSorting(row) {
    return row.hierarchyType === CONSTANTS.ROW_HIERARCHY.PARENT ? row.id : row.originatingTaskId ?? '';
}

const CONSTANTS = {
    STATUS: {
        NOT_SAVED: 'Not Saved',
        ERROR: 'Error',
        SAVING: 'Saving...',
        SAVED: 'Saved'
    },
    SORT: {
        UP: 'up',
        DOWN: 'down'
    },
    FIELDS: {
        LOCATION: 'location',
        TASK_TYPE: 'taskType',
        OPERATOR: 'operator',
        EQUIPMENT: 'equipment',
        BLAST_PACKET: 'blastPacket',
        RING: 'ring',
        IGNORE_ACTUALS: 'ignoreActuals',
        CUT_ID: 'cutId',
        START_CHAINAGE: 'startChainage',
        END_CHAINAGE: 'endChainage'
    },
    ROW_HIERARCHY: {
        CHILD: 'child',
        PARENT: 'parent',
        INDIV: 'individual'
    }
}

export default Vue.extend({
    components: { OperatorCompletionSheet, StandardDialog, RejectedTasksSheet },
    props: {
        editing: { type: Boolean, default: false },
        refreshRequiredToggle: { type: Boolean, default: false },
        actualCuts: { type: Array, default: () => [] }
    },
    computed: {
        DataAppSource() {
            return DataAppSource
        },
        ...mapState(useDepartmentStore, ['departmentName', 'departmentFeatures', 'departmentId', 'locations', 'locationName', 'taskTypes']),
        ...mapState(useShiftWindowActuals, ['getBlastPacketsInformation']),
        ...mapState(useBlastPacketsStore, ['blastPackets', 'getFlattenedBlastPackets']),
        ...mapState(useSystemStore, ['staffMembers']),
        ...mapState(useShiftDetails, ['shiftId', 'shiftName', 'shiftStartTime']),
        groupingKeySelector() {
            if(this.showDuplicatesView){
                return this.duplicatesGroupingKeySelector;
            }

            return row => row.originatingTaskId;
        },
        duplicatesGroupingKeySelector() {
            return this.displayBlastPacketsAndRings ? row => `${row.taskTypeId}_${row.equipmentId}_${row.locationId}_${row.operatorId}_${row.blastPacketId}_${row.ringId}` :
                row => `${row.taskTypeId}_${row.equipmentId}_${row.locationId}_${row.operatorId}`;
        },
        groupedFields() {
            if(this.displayParentRows){
                if(this.showDuplicatesView)
                    return [CONSTANTS.FIELDS.LOCATION, CONSTANTS.FIELDS.TASK_TYPE, CONSTANTS.FIELDS.EQUIPMENT, CONSTANTS.FIELDS.OPERATOR, ...(this.displayBlastPacketsAndRings ? [CONSTANTS.FIELDS.BLAST_PACKET, CONSTANTS.FIELDS.RING] : [])];
                else
                    return [CONSTANTS.FIELDS.LOCATION, CONSTANTS.FIELDS.TASK_TYPE];
            }
            return [];
        },
        potentialDuplicatesCount() {
            const grouped = _.groupBy(this.formData.actualsRows.filter(x=>x.hierarchyType !== CONSTANTS.ROW_HIERARCHY.PARENT), this.duplicatesGroupingKeySelector);

            return Object.values(grouped).filter(group => group.length > 1).reduce((sum, group) => sum + group.length, 0);
        },
        notDoneTasksCount() {
            return this.tasksNotDone.length;
        },
        displayParentRows() {
            return this.multiSortCriteria && !this.multiSortCriteria.some(c=>c.field !== CONSTANTS.FIELDS.LOCATION && c.field !== CONSTANTS.FIELDS.TASK_TYPE);
        },
        filtersActive() {
            return this.activeFilteredTaskType || this.activeFilteredEquipment || this.activeFilteredLocation || this.activeFilteredOperator;
        },
        displayBlastPacketsAndRings() {
              return this.locations.some(x=>x.miningMethod === MiningMethodType.SubLevelCaving);
        },
        displaySyncTimesButton() {
            return this.dataLoaded && this.editing && this.formData.actualsRows.length > 0;
        },
        filteredAndGroupedActuals() {
            if (this.displayParentRows) {
                return this.filteredActuals;
            }

            return this.filteredActuals.filter(x=>x.hierarchyType !== this.CONSTANTS.ROW_HIERARCHY.PARENT);
        },
        disableInputs() {
            return !this.editing || this.uiLocked || this.showDuplicatesView;
        },
        filteredActuals() {
            if(this.showDelays && !this.showDuplicatesView) {
                return this.formData.actualsRows;
            } else {
                const delayTaskTypes = this.showDelays ? [] : this.taskTypes.filter(tt => tt.isDelay).map(tt => tt.id);

                return this.formData.actualsRows.filter(row => !delayTaskTypes.includes(row.taskTypeId) && (!this.showDuplicatesView || row.hierarchyType !== CONSTANTS.ROW_HIERARCHY.INDIV));
            }
        },
        permittedRingsList() {
            return _.flatMap(this.getFlattenedBlastPackets, (bp)=>bp.rings.map(r => ({
                id: r.ringId,
                name: r.ringName,
                locationId: r.locationId,
                blastPacketId: bp.blastPacketId
            })));
        },
        permittedBlastPacketsList() {
            return _.flatMap(this.blastPackets, (bpl)=>bpl.blastPackets.map(bp=>({
                locationId: bpl.id,
                id: bp.id,
                name: RemoveLocationNameFromBlastPacketOrRingName(bp.name),
            })));
        },
        permittedTaskTypeList()
        {
            return this.taskTypeList.filter(tt => !tt.isArchived || this.formData.actualsRows?.some(x => x.taskTypeId === tt.id));
        },
        nonArchivedGroups() {
            if(this.actualsGroups == null)
                return null;

            return this.actualsGroups
                .map(g=>({
                    ...g,
                    definitions: g.definitions.filter(d=>!d.isArchived || this.filteredActuals.some(r=>r.actualsPairs[this.getActualsPairKey(g.groupId, d.id)] !== undefined)),
                    definitionsWithData: g.definitions.filter(d=>this.filteredActuals.some(r=>r.actualsPairs[this.getActualsPairKey(g.groupId, d.id)] !== undefined))
                }))
                .filter(g=>g.definitionsWithData.length > 0 || (g.definitions.length > 0 && !g.isArchived));
        }
    },
    data() {
        return {
            uiLocked: false,
            dataLoaded: false,
            entriesColumnCount: 0,
            formData: {
                actualsRows: []
            },
            tasksNotDone: [],
            tasksNotDoneHeaders: [
                { text: 'Name', value: 'reportingStaff.name', sortable: true },
                { text: 'Task', value: 'taskType.name', sortable: true },
                { text: 'Location', value: 'location.name', sortable: true },
                { text: 'Equipment', value: 'equipment.name', sortable: true },
                { text: 'Reason', value: 'reason', sortable: false, width: '300px' },
            ],
            actualsGroups: [],
            equipmentList: null,
            locationList: null,
            taskTypeList: null,
            operatorsList: null,
            pageStatus: '',
            saving: false,
            debouncedSaveFn: null,
            formulaDependencies: [],
            totals: {},
            tableKey: 0,  // Add this counter to force the table to re-render when the data changes,
            definitionsIndex: [], // For quick look up of definitions
            shiftIdentifier: '',
            lastDeletedPlod: null,
            filterOptions: {
                equipments: [],
                locations: [],
                taskTypes: [],
                operators: []
            },
            filterEquipment: [],
            filterLocation: [],
            filterTaskType: [],
            filterOperator: [],
            activeFilteredEquipment: false,
            activeFilteredLocation: false,
            activeFilteredTaskType: false,
            activeFilteredOperator: false,
            filterRefresh: false,
            showDelays: true,
            showDuplicatesView: false,
            multiSortMenu: false,
            multiSortCriteria: [{ field: CONSTANTS.FIELDS.TASK_TYPE, direction: CONSTANTS.SORT.UP}], // [{ field: 'location'|'taskType'|'operator'|'equipment', direction: 'up'|'down' }]
            multiSortWorking: [],
            multiSortableFields: [
                { text: 'Location', value: CONSTANTS.FIELDS.LOCATION },
                { text: this.$t('plod-entry.task-type-column'), value: CONSTANTS.FIELDS.TASK_TYPE },
                { text: 'Equipment', value: CONSTANTS.FIELDS.EQUIPMENT },
                { text: 'Operator', value: CONSTANTS.FIELDS.OPERATOR },
            ],
            sortDirections: [
                { text: 'Ascending', value: CONSTANTS.SORT.UP },
                { text: 'Descending', value: CONSTANTS.SORT.DOWN },
            ],
            filterOptionsAll: { key: null, value: 'All' },
            comboUnknownOption: { id: 'unknown', name: 'Unknown' },
            tableHeight: null,
            valueSets: {},
            areReportable: false,
            tasksNotDoneDialog: false,
            expandedReasons: {},
            operatorCompletionDialog: false,
            operatorCompletionInformation: null,
            CONSTANTS: CONSTANTS,
        };
    },
    created() {
        this.debouncedSaveFn = _.debounce(() => {
            if (!this.saving) {
                this.save();
            }
        }, 5000);

        this.filterEquipment = [];
        this.filterLocation = [];
        this.filterTaskType = [];
        this.filterOperator = [];

        this.loadData();
    },
    mounted() {

    },
    methods: {
        toggleDuplicatesView() {
            this.showDuplicatesView = !this.showDuplicatesView;

            if(this.showDuplicatesView)
                this.loadData(true);
            else
                this.loadData(false);
        },
        toggleReasonExpansion(taskId) {
            this.$set(this.expandedReasons, taskId, !this.expandedReasons[taskId]);
        },
        addMultiSortLevel() {
            // Add next available field not already chosen; default to LOCATION if none
            const chosen = new Set(this.multiSortCriteria.map(c => c.field));
            const available = this.multiSortableFields.map(f=>f.value).filter(v => !chosen.has(v));
            if (this.multiSortCriteria.length >= 3 || available.length === 0) return;
            const defaultField = available[0] ?? this.CONSTANTS.FIELDS.LOCATION;
            this.multiSortCriteria.push({ field: defaultField, direction: this.CONSTANTS.SORT.UP });
        },
        removeMultiSort(idx) {
            this.multiSortCriteria.splice(idx, 1);
        },
        addMultiSortLevelWorking() {
            // Add next available field not already chosen; default to LOCATION if none
            const chosen = new Set(this.multiSortWorking.map(c => c.field));
            const available = this.multiSortableFields.map(f=>f.value).filter(v => !chosen.has(v));
            if (this.multiSortWorking.length >= 3 || available.length === 0) return;
            const defaultField = available[0] ?? this.CONSTANTS.FIELDS.LOCATION;
            this.multiSortWorking.push({ field: defaultField, direction: this.CONSTANTS.SORT.UP });
        },
        removeMultiSortWorking(idx) {
            this.multiSortWorking.splice(idx, 1);
        },
        cancelMultiSort() {
            // Close the menu and discard any un-applied changes
            this.multiSortMenu = false;
        },
        applyMultiSort() {
            // Remove duplicates by keeping first occurrence from working copy
            const seen = new Set();
            const cleaned = (this.multiSortWorking || []).filter(c => {
                if (!c?.field) return false;
                if (seen.has(c.field)) return false;
                seen.add(c.field);
                return true;
            }).slice(0,3);

            // Apply to live criteria only on Apply
            this.multiSortCriteria = cleaned;
            this.sort(this.formData.actualsRows);

            this.multiSortMenu = false;
        },
        onMultiSortMenuChange(isOpen) {
            if (isOpen) {
                this.multiSortWorking = this.multiSortCriteria.map(c => ({ field: c.field, direction: c.direction }));
            }
        },
        isFieldSorted(field) {
            return this.multiSortCriteria.some(c => c.field === field);
        },
        fieldSortDirection(field) {
            const c = this.multiSortCriteria.find(c => c.field === field);
            return c ? c.direction : this.CONSTANTS.SORT.UP;
        },
        groupIsRelevantToTaskType(group, taskTypeId){
            return groupIsRelevantToTaskType(group, taskTypeId);
        },
        toggleMode() {
            this.$emit('custom-event');
        },
        async deleteActuals(row) {
            if (await this.$refs.confirm.openAsDeleteResource(this.$termSync('Actuals Entry'), {})) {
                // Keep a deep copy so we can undo
                this.lastDeletedPlod = _.cloneDeep(row);
                try {
                    await Actuals.deleteActuals(this.departmentId, row.id);
                    this.removeRowFromActuals(row);
                    EventBus.$emit(Events.ToastSuccess, `${this.$termSync('Actuals Entry')} Deleted`);
                } catch (error) {
                    // If delete fails, clear the lastDeletedPlod as nothing was deleted
                    this.lastDeletedPlod = null;
                    Logging.error(error);
                    EventBus.$emit(Events.ToastError, this.$t('plod-entry.error-deleting-term', { term: this.$termSync('Actuals Entry') }));
                }
            }
        },
        undoLastDeletedPlod() {
            if (!this.lastDeletedPlod)
                return;

            let restored = _.cloneDeep(this.lastDeletedPlod);
            restored.id = uuidv4();
            restored.status = CONSTANTS.STATUS.NOT_SAVED;
            restored.actualsPairs = restored.actualsPairs || {};

            // If the row was a child but its parent no longer exists, convert to individual
            if (restored.hierarchyType === this.CONSTANTS.ROW_HIERARCHY.CHILD) {
                const parentExists = this.formData.actualsRows.some(r => r.id === restored.originatingTaskId && r.hierarchyType === this.CONSTANTS.ROW_HIERARCHY.PARENT);
                if (!parentExists) {
                    restored.hierarchyType = this.CONSTANTS.ROW_HIERARCHY.INDIV;
                }
            }

            // Insert back into list
            if (restored.hierarchyType === this.CONSTANTS.ROW_HIERARCHY.CHILD) {
                const parentIndex = this.formData.actualsRows.findIndex(r => r.id === restored.originatingTaskId && r.hierarchyType === this.CONSTANTS.ROW_HIERARCHY.PARENT);
                if (parentIndex >= 0)
                    this.formData.actualsRows.splice(parentIndex + 1, 0, restored);
                else
                    this.formData.actualsRows.push(restored);
            } else {
                this.formData.actualsRows.push(restored);
            }

            // Recalc totals and trigger save
            this.reCalculateParentTotalsForRow(restored);
            this.recalculateTotals();
            this.pageStatus = CONSTANTS.STATUS.NOT_SAVED;
            if (this.debouncedSaveFn)
                this.debouncedSaveFn();

            this.lastDeletedPlod = null;
            EventBus.$emit(Events.ToastSuccess, `${this.$termSync('Actuals Entry')} Restored`);
        },
        removeRowFromActuals(row) {
            const originatingTaskId = row.originatingTaskId;

            this.formData.actualsRows = this.formData.actualsRows.filter(r => r.id !== row.id);

            if(originatingTaskId != null && this.formData.actualsRows.filter(r => r.originatingTaskId === originatingTaskId).length === 0) {
                this.formData.actualsRows = this.formData.actualsRows.filter(r => r.id !== originatingTaskId || r.hierarchyType !== this.CONSTANTS.ROW_HIERARCHY.PARENT);
            } else {
                this.reCalculateParentTotalsForRow(row);
            }
        },
        changeSorting(column) {
            // Clicking a header should behave as before and discard any existing multi-sort
            const existingSortDirection = this.multiSortCriteria.length === 1 && this.multiSortCriteria[0].field === column ? this.multiSortCriteria[0].direction : CONSTANTS.SORT.DOWN;
            this.multiSortCriteria = [{
                field: column,
                direction: existingSortDirection === CONSTANTS.SORT.UP ? CONSTANTS.SORT.DOWN : CONSTANTS.SORT.UP,
            }];

            this.sort(this.formData.actualsRows);
        },
        sort(actualsRows) {
            // Multi-column sort support (up to 3)
            const getFieldComparator = (field) => {
                switch (field) {
                    case CONSTANTS.FIELDS.LOCATION:
                        return locationSortComparator;
                    case CONSTANTS.FIELDS.TASK_TYPE:
                        return taskTypeSortComparator;
                    case CONSTANTS.FIELDS.OPERATOR:
                        return operatorSortComparator;
                    case CONSTANTS.FIELDS.EQUIPMENT:
                        return equipmentSortComparator;
                    default:
                        return fallbackComparator;
                }
            }


            // If multi-sort is configured, apply it and return
            if (this.multiSortCriteria && this.multiSortCriteria.length > 0) {
                const crits = this.multiSortCriteria
                    .filter(c => c && c.field && (c.direction === CONSTANTS.SORT.UP || c.direction === CONSTANTS.SORT.DOWN))
                    .slice(0, 3);

                const comparator = (a, b) => {
                    let index = 0;
                    for (const c of crits) {
                        index++;
                        const sortMultiplier = c.direction === CONSTANTS.SORT.UP ? 1 : -1;
                        const comparator = getFieldComparator(c.field);
                        const sortValue = comparator(a, b, sortMultiplier, index === crits.length);
                        if(sortValue === 0)
                            continue;

                        return sortValue;
                    }
                    // Always keep task hierarchy grouping as final tiebreaker
                    return hierarchyAndOriginatingTaskComparator(a, b);
                };

                actualsRows.sort(comparator);
            }
        },
        getShiftName() {
            return `${this.shiftName} - ${dayjs(this.shiftStartTime).format(DateFormat.WeekDisplay)}`;
        },
        async populateShiftData() {
            this.$wait.start('loading data');

            try {
                await Actuals.populateFromShiftPlan(this.departmentId, this.shiftId);

                EventBus.$emit(Events.ToastSuccess, this.$t('plod-entry.actuals-populated-from-shift-plan'));

                // don't manually refresh, because we're about to be told to refresh anyway
                this.$emit('refresh-required');
            } catch (e) {
                Logging.error(e);
                EventBus.$emit(Events.ToastError, this.$t('plod-entry.error-populating-actuals-from-shift-plan', { error: e.message }));
            } finally {
                this.$wait.end('loading data');
            }
        },
        processFormulasInDefinitions() {
            for (let g = 0; g < this.actualsGroups.length; g++) {
                let currentGroup = this.actualsGroups[g];

                for (let d = 0; d < currentGroup.definitions.length; d++) {
                    let item = currentGroup.definitions[d];

                    if (item.definitionType !== 'Formula' || !item.formula)
                        continue;

                    item.formulaDecimalPlaces = item.decimalPlaces;
                    let lowercaseFormula = item.formula.toLowerCase();
                    item.processedFormula = lowercaseFormula;

                    const regex = /\[(.*?)\]/g;
                    item.isFormulaProcessed = true;

                    for (const match of lowercaseFormula.matchAll(regex)) {
                        let definitionName = match[1];

                        const foundDefinition = currentGroup.definitions.find(i => i.definitionName.toLowerCase() === definitionName.toLowerCase());
                        if (!foundDefinition) {
                            item.isFormulaProcessed = false;
                            break;
                        }

                        let definitionId = foundDefinition.id;

                        // Add to formulaDependencies to know which column to trigger recalculation
                        if (!this.formulaDependencies.includes(this.getActualsPairKey(currentGroup.groupId, definitionId)))
                            this.formulaDependencies.push(this.getActualsPairKey(currentGroup.groupId, definitionId));

                        item.processedFormula = item.processedFormula.replace(`[${definitionName}]`, `[${this.getActualsPairKey(currentGroup.groupId, definitionId)}]`);
                    }

                    if (item.isFormulaProcessed)
                        item.formulaDescription = item.formula;
                    else {
                        Logging.warning('Error processing formula', item.formula);
                        item.formulaDescription = this.$t('plod-entry.error-processing-formula') + item.formula;
                    }
                }
            }
        },
        async taskTypeChanged() {
            const uniqueTaskTypeIds = [...new Set(
                this.formData.actualsRows
                    .map(row => row.isCustom ? row.taskType?.id : row.taskTypeId)
                    .filter(Boolean) // Remove falsy values
            )];

            this.actualsGroups = await Actuals.getGroups(this.departmentId, uniqueTaskTypeIds);

            this.processFormulasInDefinitions();

            // Trigger table to re-render
            this.tableKey += 1;
        },
        handleInputChange(row, actualsChanged, headerGroup, target) {
            if(row.hierarchyType === this.CONSTANTS.ROW_HIERARCHY.PARENT && target === CONSTANTS.FIELDS.LOCATION)
            {
                this.changeHeaderItemLocation(row);
                return;
            }

            // Handle cut/chainage validation for INDIV and CHILD rows
            if ((row.hierarchyType === this.CONSTANTS.ROW_HIERARCHY.INDIV || row.hierarchyType === this.CONSTANTS.ROW_HIERARCHY.CHILD) &&
                (target === null || target === this.CONSTANTS.FIELDS.CUT_ID || 
                 target === this.CONSTANTS.FIELDS.START_CHAINAGE || 
                 target === this.CONSTANTS.FIELDS.END_CHAINAGE)) {
                
                // Auto-clear conflicting fields
                if (target === this.CONSTANTS.FIELDS.CUT_ID && row.cutId != null && row.cutId !== '') {
                    // If cutId is being set, clear chainages
                    row.startChainage = null;
                    row.endChainage = null;
                } else if (target === this.CONSTANTS.FIELDS.START_CHAINAGE || 
                           target === this.CONSTANTS.FIELDS.END_CHAINAGE) {
                    // If chainage is being set, clear cutId
                    if ((row.startChainage != null && row.startChainage !== '') || 
                        (row.endChainage != null && row.endChainage !== '')) {
                        row.cutId = null;
                    }
                }
                
                // Validate the rules
                const validation = this.validateCutAndChainage(row);
                if (!validation.isValid) {
                    row.status = CONSTANTS.STATUS.ERROR;
                    row.validationError = validation.message;
                    this.pageStatus = CONSTANTS.STATUS.NOT_SAVED;
                    // Don't call debouncedSaveFn if validation fails
                    return;
                } else {
                    // Clear validation error if validation passes
                    if (row.validationError) {
                        row.validationError = null;
                    }
                }
            }

            // this should not be possible, but we'll throw it out just in case
            if(row.hierarchyType === this.CONSTANTS.ROW_HIERARCHY.PARENT)
                return;

            switch (target) {
                case CONSTANTS.FIELDS.TASK_TYPE:
                    if(row.originatingTaskId != null)
                        row.originatingTaskId = null;
                    row.taskTypeId = row.taskType.id;
                    this.taskTypeChanged();
                    break;
                case CONSTANTS.FIELDS.OPERATOR:
                    row.operatorId = row.operator.id;
                    break;
                case CONSTANTS.FIELDS.LOCATION:
                    if(row.originatingTaskId != null)
                        row.originatingTaskId = null;
                    row.locationId = row.location.id;
                    if(row.blastPacket != null && !this.getPermittedBlastPacketsForLocation(row.location).some(x=>x.id === row.blastPacket.id))
                        row.blastPacket = null;
                    if(row.ring != null && !this.getPermittedRingsForLocation(row.location, row.blastPacket).some(x=>x.id === row.ring.id))
                        row.ring = null;
                    // Clear cut/chainage fields when location changes for INDIV rows
                    if(row.hierarchyType === this.CONSTANTS.ROW_HIERARCHY.INDIV) {
                        row.cutId = null;
                        row.startChainage = null;
                        row.endChainage = null;
                    }
                    break;
                case CONSTANTS.FIELDS.BLAST_PACKET:
                    if(row.originatingTaskId != null)
                        row.originatingTaskId = null;
                    row.blastPacketId = row.blastPacket?.id;
                    if(row.ring != null && !this.getPermittedRingsForLocation(row.location, row.blastPacket).some(x=>x.id === row.ring.id))
                        row.ring = null;
                    break;
                case CONSTANTS.FIELDS.EQUIPMENT:
                    row.equipmentId = row.equipment.id;
                    break;
            }

            if (actualsChanged && this.formulaDependencies.includes(`${this.getActualsPairKey(headerGroup.groupId,actualsChanged.id)}`)) {
                this.recalculateFormulaForRow(row);
            }

            this.recalculateTotals();
            if(actualsChanged != null && headerGroup != null)
                this.reCalculateParentTotals(row, null, null); // for now we'll need to update all until we work out how to handle formulae
            else if(target === CONSTANTS.FIELDS.IGNORE_ACTUALS)
                this.reCalculateParentTotalsForRow(row);

            row.status = CONSTANTS.STATUS.NOT_SAVED;
            this.pageStatus = CONSTANTS.STATUS.NOT_SAVED;
            this.debouncedSaveFn();
        },
        changeHeaderItemLocation(row) {
            const affectedRows = this.formData.actualsRows.filter(r => r.originatingTaskId === row.id && r.hierarchyType !== this.CONSTANTS.ROW_HIERARCHY.PARENT);

            affectedRows.forEach(r => {
                r.location = row.location;
                r.locationId = row.location.id;
                r.locationDisplayName = row.location.name;
                // Clear cut/chainage fields for CHILD rows when PARENT location changes
                r.cutId = null;
                r.startChainage = null;
                r.endChainage = null;
                r.status = CONSTANTS.STATUS.NOT_SAVED;
            });
            this.pageStatus = CONSTANTS.STATUS.NOT_SAVED;
            this.debouncedSaveFn();
        },
        reCalculateParentTotals(item, updatedGroup, updatedDefinition) {
            if(item.hierarchyType === this.CONSTANTS.ROW_HIERARCHY.INDIV || !item.originatingTaskId)
                return;

            if(updatedDefinition != null && !definitionCanBeSummed(updatedDefinition))
                return;

            let parentRow = this.formData.actualsRows.find(r => r.hierarchyType === this.CONSTANTS.ROW_HIERARCHY.PARENT && r.id === item.originatingTaskId);
            if(parentRow == null)
                return;

            let parentGroup = this.formData.actualsRows.filter(x=>x.originatingTaskId === item.originatingTaskId && x.hierarchyType !== this.CONSTANTS.ROW_HIERARCHY.PARENT);

            if(updatedGroup != null && updatedDefinition != null){
                const pairKey = this.getActualsPairKey(updatedGroup.groupId, updatedDefinition.id);

                const recalculatedTotal = this.calculateParentTotalsForGroup(parentGroup, [{ id: updatedDefinition.id, groupId: updatedGroup.groupId, decimalPlaces: updatedDefinition.decimalPlaces }]);

                parentRow.actualsPairs[pairKey] = recalculatedTotal[pairKey];
            } else {
                parentRow.actualsPairs = this.calculateParentTotalsForGroup(parentGroup);
            }
        },
        reCalculateParentTotalsForRow(item) {
            this.reCalculateParentTotals(item, null, null);
        },
        calculateParentTotalsForGroup(group, targetDefinitions = null) {
            const relevantDefinitions = targetDefinitions ?? this.actualsGroups
                .flatMap(group => group.definitions.map(def => ({ ...def, groupId: group.groupId })))
                .filter(def => definitionCanBeSummed(def));

            let headingResults = {};

            relevantDefinitions.forEach(({ id, groupId, decimalPlaces = 1 }) => {
                const key = this.getActualsPairKey(groupId, id);
                headingResults[key] = group
                    .reduce((sum, row) => {
                        if(!row.ignoreValuesForReporting && row.actualsPairs[key] !== undefined)
                            return sum + +row.actualsPairs[key];
                        else
                            return sum;
                    }, null)
                    ?.toFixed(decimalPlaces);
            });

            return headingResults;
        },
        recalculateTotals() {
            // TODO: Optimize recalculation of totals to limit it to only the changed column (taking into account formula recalculations)

            for (let g = 0; g < this.actualsGroups.length; g++) {
                let currentGroup = this.actualsGroups[g];

                let lowercasedGroupId = currentGroup.groupId.toLowerCase();

                for (let d = 0; d < currentGroup.definitions.length; d++) {
                    let currentDefinition = currentGroup.definitions[d];

                    if (!definitionCanBeSummed(currentDefinition))
                        continue;

                    let cellId = this.getActualsPairKey(lowercasedGroupId, currentDefinition.id);
                    let currentTotal = 0;

                    this.formData.actualsRows.filter(x=>!x.ignoreValuesForReporting && x.hierarchyType !== this.CONSTANTS.ROW_HIERARCHY.PARENT).map(r => {
                        if (r.actualsPairs[cellId] !== undefined)
                            currentTotal += +r.actualsPairs[cellId];
                    });

                    let decimalPlaces = currentDefinition.decimalPlaces ? currentDefinition.decimalPlaces : 1;
                    if (currentDefinition.definitionType === 'Formula' || currentDefinition.definitionType === 'Decimal') {
                        currentTotal = currentTotal.toFixed(decimalPlaces);
                    }

                    this.totals[cellId] = currentTotal;
                }
            }
        },
        recalculateFormulaForRow(row) {
            if(row.hierarchyType === this.CONSTANTS.ROW_HIERARCHY.PARENT)
                return;

            // Have to do it from actualsGroups because actualValues only come back when there are values
            for (let g = 0; g < this.actualsGroups.length; g++) {
                let currentGroup = this.actualsGroups[g];

                // Do not continue with group if not associated with the taskType
                if (!groupIsRelevantToTaskType(currentGroup, row.taskType.id))
                    continue;

                let lowercasedGroupId = currentGroup.groupId.toLowerCase();

                for (let d = 0; d < currentGroup.definitions.length; d++) {
                    let currentDefinition = currentGroup.definitions[d];

                    if (currentDefinition.definitionType === 'Formula' && currentDefinition.isFormulaProcessed) {

                        const regex = /\[(.*?)\]/g;

                        let formulaExpression = currentDefinition.processedFormula;

                        let hasUnmatched = false;
                        for (const match of formulaExpression.matchAll(regex)) {
                            let matchedValue = row.actualsPairs[match[1]];

                            if (matchedValue === undefined || matchedValue === null || matchedValue === '')
                                hasUnmatched = true;

                            formulaExpression = formulaExpression.replace(`[${match[1]}]`, `${matchedValue}`);
                        }

                        // Check that all [x] expressions have been found
                        if (formulaExpression.indexOf('[') < 0 && !hasUnmatched) {
                            let evaluatedResult = eval(formulaExpression).toFixed(currentDefinition.formulaDecimalPlaces);

                            // If we want to remove trailing 0s
                            // evaluatedResult = parseFloat(evaluatedResult);

                            row.actualsPairs[this.getActualsPairKey(lowercasedGroupId, currentDefinition.id)] = evaluatedResult;
                        } else if(hasUnmatched && row.actualsPairs[this.getActualsPairKey(lowercasedGroupId, currentDefinition.id)] != null) {
                            // if we have previously calculated this value but now no longer can, null it out
                            row.actualsPairs[this.getActualsPairKey(lowercasedGroupId, currentDefinition.id)] = null;
                        }
                    }
                }
            }
        },
        async save() {
            if (this.pageStatus === CONSTANTS.STATUS.ERROR)
                return false;

            let saveError = false;

            // Process and save all actuals rows that have been modified
            let updateCommands = [];
            let rowsToSave = this.formData.actualsRows.filter(i => i.status === CONSTANTS.STATUS.NOT_SAVED && i.taskType);

            // Validate cut/chainage for INDIV and CHILD rows before saving
            rowsToSave.forEach(row => {
                if (row.hierarchyType === this.CONSTANTS.ROW_HIERARCHY.INDIV || row.hierarchyType === this.CONSTANTS.ROW_HIERARCHY.CHILD) {
                    const validation = this.validateCutAndChainage(row);
                    if (!validation.isValid) {
                        row.status = CONSTANTS.STATUS.ERROR;
                        row.validationError = validation.message;
                        saveError = true;
                    }
                }
            });

            if (saveError) {
                this.pageStatus = CONSTANTS.STATUS.ERROR;
                EventBus.$emit(Events.ToastError, this.$t('plod-entry.please-fix-validation-errors'));
                return false;
            }

            rowsToSave.map(rowToSave => {
                let updateCommand = {
                    id: rowToSave.id,
                    equipmentId: rowToSave.equipment ? rowToSave.equipment.id : null,
                    operatorId: rowToSave.operator ? rowToSave.operator.id : null,
                    taskTypeId: rowToSave.taskType ? rowToSave.taskType.id : null,
                    taskTypeDisplayName: rowToSave.taskTypeDisplayName,
                    blastPacketId: rowToSave.blastPacket ? rowToSave.blastPacket.id : null,
                    locationRingId: rowToSave.ring ? rowToSave.ring.id : null,
                    comment: rowToSave.comment,
                    startTime: rowToSave.startTime,
                    endTime: rowToSave.endTime,
                    isCustom: rowToSave.isCustom,
                    originatingTaskId: rowToSave.originatingTaskId,
                    ignoreValuesForReporting: rowToSave.ignoreValuesForReporting,
                    actualCutId: (rowToSave.hierarchyType === this.CONSTANTS.ROW_HIERARCHY.INDIV || rowToSave.hierarchyType === this.CONSTANTS.ROW_HIERARCHY.CHILD) ? rowToSave.cutId : null,
                    startChainage: (rowToSave.hierarchyType === this.CONSTANTS.ROW_HIERARCHY.INDIV || rowToSave.hierarchyType === this.CONSTANTS.ROW_HIERARCHY.CHILD) ? (rowToSave.startChainage != null ? parseFloat(rowToSave.startChainage) : null) : null,
                    endChainage: (rowToSave.hierarchyType === this.CONSTANTS.ROW_HIERARCHY.INDIV || rowToSave.hierarchyType === this.CONSTANTS.ROW_HIERARCHY.CHILD) ? (rowToSave.endChainage != null ? parseFloat(rowToSave.endChainage) : null) : null,
                    completionPercent: rowToSave.completionPercent,
                    actualsValues: []
                };

                // Check if location is a custom string, otherwise set to what is in combobox
                if (rowToSave.location && typeof rowToSave.location === 'string') {
                    updateCommand.locationId = null;
                    updateCommand.locationDisplayName = rowToSave.location;
                } else {
                    updateCommand.locationDisplayName = null;
                    updateCommand.locationId = rowToSave.location ? rowToSave.location.id : null;
                }

                // Set any combo box 'unknown' values to unknown flag
                if (updateCommand.equipmentId === 'unknown') {
                    updateCommand.equipmentId = null;
                    updateCommand.isEquipmentUnknown = true;
                }
                if (updateCommand.locationId === 'unknown') {
                    updateCommand.locationId = null;
                    updateCommand.isLocationUnknown = true;
                }
                if (updateCommand.operatorId === 'unknown') {
                    updateCommand.operatorId = null;
                    updateCommand.isOperatorUnknown = true;
                }

                for (let g = 0; g < this.actualsGroups.length; g++) {
                    let currentGroup = this.actualsGroups[g];

                    if (groupIsRelevantToTaskType(currentGroup, rowToSave.taskType.id)) {
                        let lowercasedGroupId = currentGroup.groupId.toLowerCase();

                        for (let d = 0; d < currentGroup.definitions.length; d++) {
                            let currentDefinition = currentGroup.definitions[d];

                            // Do not add if there are no recorded values
                            if (!rowToSave.actualsPairs[this.getActualsPairKey(lowercasedGroupId, currentDefinition.id)])
                                continue;

                            let defValue = {
                                actualsDefinitionId: currentDefinition.id,
                                actualsGroupId: lowercasedGroupId,
                                value: rowToSave.actualsPairs[this.getActualsPairKey(lowercasedGroupId, currentDefinition.id)],
                                type: this.getTypeStringAsNumber(currentDefinition.definitionType)
                            };

                            updateCommand.actualsValues.push(defValue);
                        }
                    }
                }

                updateCommands.push(updateCommand);
            });

            if (updateCommands.length > 0) {
                this.uiLocked = true;
                this.saving = true;
                this.pageStatus = CONSTANTS.STATUS.SAVING;

                try {
                    await Actuals.update(this.departmentId, this.shiftId, updateCommands);
                } catch (e) {
                    saveError = true;
                    Logging.error(e);

                    rowsToSave.map(i => {
                        i.status = CONSTANTS.STATUS.ERROR;
                    });
                } finally {
                    this.saving = false;
                    this.uiLocked = false;

                    if (!saveError) {
                        this.pageStatus = CONSTANTS.STATUS.SAVED;

                        rowsToSave.map(i => {
                            i.status = '';
                        });
                    } else
                        this.pageStatus = CONSTANTS.STATUS.ERROR;
                }
            }

            return !saveError;
        },
        async cancelReportability() {
            if(await this.confirmCancelReportability()) {
                await this.markAsNotReportable();
            }
        },
        async markReportable() {
            if(await this.confirmReadyToReport()) {
                await this.markAsReportable();
            }
        },
        async confirmCancelReportability() {
            // @ts-ignore
            return await this.$refs.confirm.open(
                this.$t('plod-entry.cancel-reportability'),
                this.$t('plod-entry.confirm-mark-not-ready'),
                { color: 'red' }
            );
        },
        async confirmReadyToReport(){
            // @ts-ignore
            return await this.$refs.confirm.multilineOpen(
                this.$t('plod-entry.mark-reportable'),
                [this.$t('plod-entry.confirm-mark-ready'), this.$t('plod-entry.changes-still-possible')],
                { color: 'orange' }
            );
        },
        async markAsReportable() {
            if (this.pageStatus === CONSTANTS.STATUS.ERROR)
                return false;

            this.$wait.start('marking-reportable');
            try {
                await Actuals.markActualsAsApproved(this.departmentId, this.shiftId);
                this.areReportable = true;
                EventBus.$emit(Events.ToastSuccess, this.$t('plod-entry.marked-reportable'));
            } catch (error) {
                Logging.error(error);
                EventBus.$emit(Events.ToastError, this.$t('plod-entry.error-marking-reportable', { error: error.message }));
            } finally {
                this.$wait.end('marking-reportable');
            }
        },
        async markAsNotReportable() {
            if (this.pageStatus === CONSTANTS.STATUS.ERROR)
                return false;

            this.$wait.start('marking-not-reportable');
            try {
                await Actuals.markActualsAsNotApproved(this.departmentId, this.shiftId);
                this.areReportable = false;
                EventBus.$emit(Events.ToastWarning, this.$t('plod-entry.marked-not-reportable'));
            } catch (error) {
                Logging.error(error);
                EventBus.$emit(Events.ToastError, this.$t('plod-entry.error-marking-not-reportable', { error: error.message }));
            } finally {
                this.$wait.end('marking-not-reportable');
            }
        },
        getTypeStringAsNumber(typeString) {
            switch (typeString) {
                case 'Integer':
                    return 0;
                case 'Decimal':
                    return 1;
                case 'Time':
                    return 2;
                case 'Text':
                    return 3;
                case 'Formula':
                    return 4;
                case 'Boolean':
                    return 5;
                case 'Date':
                    return 6;
            }
        },
        validateInput(event, dataType) {
            let newValue = event.target.value + event.key;

            let validationRegex = null;

            if (dataType === 'Integer')
                validationRegex = /^-?\d+$/;
            else if (dataType === 'Percent')
                validationRegex = /^[1-9][0-9]?$|^100$/;
            else if (dataType === 'Decimal')
                validationRegex = /^-?\d*\.?\d*$/;
            else if (dataType === 'Chainage') {
                // Max 1 decimal place, allows 0, allows negative
                validationRegex = /^-?\d*\.?\d{0,1}$/;
            }

            if (validationRegex && !validationRegex.test(newValue)) {
                event.preventDefault();
            }
        },
        validateCutAndChainage(row) {
            const hasCutId = row.cutId != null && row.cutId !== '';
            const startChainage = row.startChainage != null && row.startChainage !== '' ? parseFloat(row.startChainage) : null;
            const endChainage = row.endChainage != null && row.endChainage !== '' ? parseFloat(row.endChainage) : null;
            const hasStartChainage = startChainage !== null && !isNaN(startChainage);
            const hasEndChainage = endChainage !== null && !isNaN(endChainage);
            
            // Rule 1: Cannot have both Cut # and chainage
            if (hasCutId && (hasStartChainage || hasEndChainage)) {
                return {
                    isValid: false,
                    message: this.$t('plod-entry.cannot-enter-both-cut-and-chainage')
                };
            }
            
            // Rule 2: Start and End chainage must both be entered together, or not at all
            if ((hasStartChainage && !hasEndChainage) || (!hasStartChainage && hasEndChainage)) {
                return {
                    isValid: false,
                    message: this.$t('plod-entry.both-chainage-together')
                };
            }
            
            // Rule 3: End chainage must be greater than start chainage
            if (hasStartChainage && hasEndChainage && endChainage <= startChainage) {
                return {
                    isValid: false,
                    message: this.$t('plod-entry.end-chainage-greater-than-start')
                };
            }
            
            return { isValid: true };
        },
        switchToEdit() {
            this.editing = true;
            this.uiLocked = false;
            this.pageStatus = '';
        },
        finishEditing() {
            if (this.pageStatus === CONSTANTS.STATUS.NOT_SAVED) {
                if (this.debouncedSaveFn)
                    this.debouncedSaveFn.cancel();

                this.save(true);
            } else {
                this.editing = false;
                this.uiLocked = true;
            }
        },
        async syncTimes() {
            if(await this.confirmSyncTimes()){
                this.$wait.start('syncing-times');
                try {
                    await Actuals.syncTimesFromShiftPlan(this.departmentId, this.shiftId);
                    EventBus.$emit(Events.ToastSuccess, this.$t('plod-entry.task-times-copied'));
                    // don't manually refresh, because we're about to be told to refresh anyway
                    this.$emit('refresh-required');
                } catch (error) {
                    Logging.error(error);
                    EventBus.$emit(Events.ToastError, this.$t('plod-entry.error-copying-task-times', { error: error.message }));
                } finally {
                    this.$wait.end('syncing-times');
                }
            }
        },
        async confirmSyncTimes(){
            // @ts-ignore
            return await this.$refs.confirm.multilineOpen(
                this.$t('plod-entry.copy-task-times'),
                [this.$t('plod-entry.confirm-copy-task-times'), this.$t('plod-entry.changes-still-possible')],
                { color: 'orange' }
            );
        },
        addRow() {
            let newItem = {
                id: uuidv4(),
                actualsPairs: {},
                status: CONSTANTS.STATUS.NOT_SAVED,
                isCustom: true,
                equipment: undefined,
                location: undefined,
                operator: undefined,
                taskType: undefined,
                hierarchyType: this.CONSTANTS.ROW_HIERARCHY.INDIV,
                cutId: null,
                actualCutId: null,
                startChainage: null,
                endChainage: null,
            };

            // Set item default values that are uneditable, if filter has been applied

            if (this.filterEquipment)
                newItem.equipment = this.equipmentList.find(i => i.id === this.filterEquipment?.key?.toLowerCase());

            if (this.filterLocation)
                newItem.location = this.locationList.find(i => i.id === this.filterLocation?.key?.toLowerCase());

            if (this.filterOperator)
                newItem.operator = this.operatorsList.find(i => i.id === this.filterOperator?.key?.toLowerCase());

            if (this.filterTaskType)
                newItem.taskType = this.taskTypeList.find(i => i.id === this.filterTaskType?.key?.toLowerCase());

            this.formData.actualsRows.push(newItem);
        },
        addChildRow(parentRow){
            let newItem = {
                id: uuidv4(),
                actualsPairs: {},
                status: CONSTANTS.STATUS.NOT_SAVED,
                isCustom: false,
                equipment: undefined,
                location: parentRow.location,
                operator: undefined,
                taskType: parentRow.taskType,
                originatingTaskId: parentRow.id,
                hierarchyType: this.CONSTANTS.ROW_HIERARCHY.CHILD,
            };

            // Set item default values that are uneditable, if filter has been applied

            if (this.filterEquipment)
                newItem.equipment = this.equipmentList.find(i => i.id === this.filterEquipment?.key?.toLowerCase());

            if (this.filterOperator)
                newItem.operator = this.operatorsList.find(i => i.id === this.filterOperator?.key?.toLowerCase());

            const parentRowIndex = this.formData.actualsRows.findIndex(r => r.id === parentRow.id);

            // splice in the new item just after the parent
            this.formData.actualsRows.splice(parentRowIndex + 1, 0, newItem);
        },
        clearFilter() {
            this.filterEquipment = [this.filterOptionsAll];
            this.filterLocation = [this.filterOptionsAll];
            this.filterTaskType = [this.filterOptionsAll];
            this.filterOperator = [this.filterOptionsAll];

            this.activeFilteredEquipment = null;
            this.activeFilteredLocation = null;
            this.activeFilteredTaskType = null;
            this.activeFilteredOperator = null;

            this.loadData(true);
        },
        filterToOperator(operatorId) {
            // Close the drawer
            this.operatorCompletionDialog = false;

            // Set the filter to this operator
            if (operatorId) {
                const operatorFilterOption = this.filterOptions.operators.find(
                    o => o.key.toUpperCase() === operatorId.toUpperCase()
                );

                if (operatorFilterOption) {
                    this.filterOperator = [operatorFilterOption];
                    this.loadData(true);
                }
            }
        },
        openOperatorCompletion() {
            // Open the drawer
            this.operatorCompletionDialog = true;
            // Load the data
            this.loadOperatorCompletion();
        },
        async loadOperatorCompletion() {
              this.operatorCompletionInformation = null;
              this.$wait.start('loading-operator-completion');
              try {
                  this.operatorCompletionInformation = await Actuals.getOperatorCompletionForDepartmentShiftId(this.departmentId, this.shiftId);
              } catch (error) {
                  // hide the drawer if it is open
                  this.operatorCompletionDialog = false;
                  Logging.error(error);
                  EventBus.$emit(Events.ToastError, this.$t('plod-entry.error-loading-operator-completion', { error: error.message }));
              } finally {
                  this.$wait.end('loading-operator-completion');
              }
        },
        async loadData(filterRefresh = false) {
            if (!this.csvExportDateRangeStart && this.shiftStartTime)
                this.csvExportDateRangeStart = this.shiftStartTime.format('YYYY-MM-DD');

            if (!this.csvExportDateRangeEnd && this.shiftStartTime)
                this.csvExportDateRangeEnd = this.shiftStartTime.format('YYYY-MM-DD');

            this.filterRefresh = filterRefresh;

            this.shiftIdentifier = this.getShiftName();

            this.equipmentList = [this.comboUnknownOption, ...await Equipment.get(['EquipmentRole', 'Departments'])];
            this.locationList = [this.comboUnknownOption, ...this.locations];
            this.taskTypeList = this.taskTypes;
            this.operatorsList = [this.comboUnknownOption, ...this.staffMembers];

            const options = await Actuals.getFilterOptionsForDepartmentShiftId(this.departmentId, this.shiftId);

            // only go and get blast packets if we're dealing with sublevel caving, otherwise it's a waste
            if(this.displayBlastPacketsAndRings)
                await useBlastPacketsStore().populateStoreForDepartment(this.$route.params.dept);

            this.filterOptions.locations = this.locations.map(l => {
                return { key: l.id, value: l.name };
            });
            this.filterOptions.equipments = options.equipments;
            this.filterOptions.taskTypes = options.taskTypes;
            this.filterOptions.operators = options.operators;

            this.loadTasksNotDone();

            const actualsResponse = await Actuals.getActualsDataForDepartmentShiftId(
                this.departmentId,
                this.shiftId,
                this.filterTaskType.filter(x=>x.key !== null).map(x=>x.key),
                this.filterOperator.filter(x=>x.key !== null).map(x=>x.key),
                this.filterEquipment.filter(x=>x.key !== null).map(x=>x.key),
                this.filterLocation.filter(x=>x.key !== null).map(x=>x.key)
            );

            let actualsRows = actualsResponse.actualsResponses;
            this.areReportable = actualsResponse.markedAsReportable;

            // Get unique taskTypeIds from actuals data
            const uniqueTaskTypeIds = Array.from(
                new Set(actualsRows.flatMap(a => a.taskTypeId))
            );

            // Get groups
            if (uniqueTaskTypeIds && uniqueTaskTypeIds.length > 0) {
                this.actualsGroups = await Actuals.getGroups(this.departmentId, uniqueTaskTypeIds);

                // Add empty value as option for value sets
                this.actualsGroups?.map(g => {
                    g.definitions?.map(d => {
                        if (d.valueSet && d.valueSet.length >= 1) {
                            this.valueSets[d.id] = ['', ...d.valueSet];
                        }
                    });
                });
            }

            this.processFormulasInDefinitions();

            const grouped = _.groupBy(actualsRows, this.groupingKeySelector);

            actualsRows = Object.entries(grouped).flatMap(([key, group]) => {
                group.map(row => {
                    // 1. Change time format to HH:mm
                    row.actualValues.map(item => {
                        if (item.type === 'Time' && item.value) {
                            // Convert to HH:mm
                            let date = new Date(item.value);
                            item.value = date.toISOString().substr(11, 5);
                        }

                        if(item.type === 'Date' && item.value) {
                            // Convert to YYYY-MM-DD
                            let date = new Date(item.value);
                            item.value = date.toISOString().substr(0, 10);
                        }

                        if (item.value && (item.type === 'Decimal' || item.type === 'Formula') && item.decimalPlaces)
                            item.value = item.value.toFixed(item.decimalPlaces);
                        else if (item.type === 'Integer')
                            item.value = item.value.toString();
                    });

                    // 2. Reduce actuals data to a key value pair, with ID being a concatenation of groupId and defId
                    row.actualsPairs = row.actualValues.reduce((acc, item) => {
                        acc[this.getActualsPairKey(item.groupId, item.actualValueId)] = item.value;

                        return acc;
                    }, {});

                    // 3. Massage equipment, location, taskType and operator into objects needed for combo boxes
                    if (row.isEquipmentUnknown)
                        row.equipment = this.comboUnknownOption;
                    else
                        row.equipment = {
                            id: row.equipmentId,
                            name: row.equipmentName
                        };

                    row.taskType = {
                        id: row.taskTypeId,
                        name: row.taskTypeName
                    };

                    row.blastPacket = row.blastPacketId != null ? {
                        id: row.blastPacketId,
                        name: row.blastPacketName
                    } : null;

                    row.ring = row.locationRingId != null ? {
                        id: row.locationRingId,
                        name: row.locationRingName
                    } : null;


                    if (row.isLocationUnknown)
                        row.location = this.comboUnknownOption;
                    else if (!row.locationId && row.locationDisplayName)
                        row.location = row.locationDisplayName;
                    else
                        row.location = {
                            id: row.locationId,
                            name: row.locationName
                        };

                    if (row.isOperatorUnknown)
                        row.operator = this.comboUnknownOption;
                    else
                        row.operator = {
                            id: row.operatorId,
                            name: row.operatorName
                        };

                    // Set cutId, startChainage, and endChainage from actuals record
                    row.actualCutId = row.actualCutId || null;
                    row.startChainage = row.startChainage != null ? row.startChainage : null;
                    row.endChainage = row.endChainage != null ? row.endChainage : null;
                });

                if(group.length === 1 || key == null || key == 'null')
                    return group.map(g=>({
                        ...g,
                        hierarchyType: this.CONSTANTS.ROW_HIERARCHY.INDIV,
                        cutId: g.actualCutId || null,
                    }));

                const [firstRow] = group;
                const { taskType, location, operator, equipment } = firstRow || {};

                const headingItem = {
                    id: key,
                    taskType,
                    location,
                    operator,
                    equipment,
                    actualsPairs: {},
                    hierarchyType: this.CONSTANTS.ROW_HIERARCHY.PARENT,
                };

                if (taskType) {
                    const relevantDefinitions = this.actualsGroups
                        .filter(g=> groupIsRelevantToTaskType(g, taskType.id))
                        .flatMap(group => group.definitions.map(def => ({ ...def, groupId: group.groupId })))
                        .filter(def => definitionCanBeSummed(def));

                    headingItem.actualsPairs = this.calculateParentTotalsForGroup(group, relevantDefinitions);
                }

                return [headingItem, ...group.map(g=>({
                    ...g,
                    hierarchyType: this.CONSTANTS.ROW_HIERARCHY.CHILD,
                }))];
            });

            // Once mounted, massage data

            this.sort(actualsRows);

            this.formData.actualsRows = actualsRows;

            // Initialize cutId, startChainage, and endChainage for INDIV and CHILD rows
            this.formData.actualsRows.forEach(row => {
                if (row.hierarchyType === this.CONSTANTS.ROW_HIERARCHY.INDIV || row.hierarchyType === this.CONSTANTS.ROW_HIERARCHY.CHILD) {
                    if (row.cutId == null) {
                        row.cutId = row.actualCutId || null;
                    }
                    if (row.startChainage == null && row.startChainage !== undefined) {
                        row.startChainage = null;
                    }
                    if (row.endChainage == null && row.endChainage !== undefined) {
                        row.endChainage = null;
                    }
                }
            });

            // Calculate formula for each row
            this.formData.actualsRows.map(row => {
                this.recalculateFormulaForRow(row);
            });

            // Calculate totals
            this.recalculateTotals();
            
            this.activeFilteredEquipment = this.filterEquipment.length > 0;
            this.activeFilteredLocation = this.filterLocation.length > 0;
            this.activeFilteredTaskType = this.filterTaskType.length > 0;
            this.activeFilteredOperator = this.filterOperator.length > 0;

            this.dataLoaded = true;
            this.filterRefresh = false;
        },
        async loadTasksNotDone() {
            try {
                this.tasksNotDone = await Actuals.getTasksNotDoneForDepartmentShiftId(this.departmentId, this.shiftId);
            } catch (error) {
                Logging.error(error);
                EventBus.$emit(Events.ToastError, this.$t('plod-entry.error-loading-rejected-tasks', { error: error.message }));
            }
        },
        getPermittedRingsForLocation(location, blastPacket) {
            if (!this.displayBlastPacketsAndRings)
                return this.permittedRingsList;

            if(location == null)
                return [];

            return this.permittedRingsList.filter(x=>x.locationId === location.id && (blastPacket?.id == null || blastPacket.id === x.blastPacketId)).map(x=>({
                ...x,
                name: RemoveLocationNameFromBlastPacketOrRingName(x.name, location.name)
            }));
        },
        getPermittedBlastPacketsForLocation(location) {
            if (!this.displayBlastPacketsAndRings)
                return this.permittedBlastPacketsList;

            if(location == null)
                return [];

            return this.permittedBlastPacketsList.filter(x=>x.locationId === location.id).map(x=>({
                ...x,
                name: RemoveLocationNameFromBlastPacketOrRingName(x.name, location.name)
            }));
        },
        getCutsForLocation(location) {
            if (!location || typeof location === 'string' || !location.id)
                return [];

            const locationId = location.id.toLowerCase();
            const cutsForLocation = this.actualCuts
                .filter(cut => cut.locationId && cut.locationId.toLowerCase() === locationId)
                .sort((a, b) => a.cutNumber - b.cutNumber)
                .map(cut => ({
                    value: cut.actualCutId,
                    text: cut.cutNumber.toString()
                }));

            return cutsForLocation;
        },
        getTextFieldType(type) {
            if (type === 'Time')
                return 'time';
            else if(type === 'Date')
                return 'date';
            else
                return 'text';
        },
        getActualsPairKey(groupId, defId) {
            return `${groupId.toLowerCase()}_${defId.toLowerCase()}`;
        }
    },
    watch: {
        async refreshRequiredToggle(newValue, oldValue) {
            if (newValue !== oldValue) {
                await this.loadData(true);
            }
        }
    }
});
</script>


<style scoped>
.totals-row > td {
    border-top: 3px SOLID #EEE !important;
}

.edit-mode .theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
    color: #FFF !important;
}

.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr:last-child > th {
    border-bottom: 1px SOLID #FFF;
}

.col-boolean {
    min-width: 50px;
}

.col-decimal {
    min-width: 70px;
}

.col-integer {
    min-width: 70px;
}

.col-formula {
    min-width: 70px;
}

.col-text {
    min-width: 100px;
}

.col-time {
    min-width: 120px;
}

.grey-box {
    background-color: #EEE;
}

.formula-indicator {
    color: darkorange;
    font-style: italic;
}

.header-s {
    font-size: 12px;
}

.header-s .edit-mode {
    background-color: #15A69A;
}

.header-s .read-mode {
    background-color: #DDD;
}

.custom-plod-table th,
.custom-plod-table td {
    border: 1px solid #FFF;
    padding: 8px 5px !important;
    height: auto !important;
    text-align: center !important;
}

.custom-plod-table {
    & table {
        /*
        Note: collapse doesn't quite work at this point because the table border gets rendered behind the cells and shifts.
        border-collapse: collapse;
        */
    }
}

.custom-plod-table {
    & td {
        border: 0 solid #FFF;
        padding: 2px 5px 2px 5px !important;
        text-align: center;
    }
}

.fixed-width-combo {
    max-width: 140px;
}

.screen-x .fixed-width-combo, .screen-l .fixed-width-combo {
    max-width: 110px;
}

.extra-wide {
    min-width: 150px;
    max-width: 150px;
}

.screen-x .extra-wide, .screen-l .extra-wide {
    min-width: 120px;
    max-width: 120px;
}

.group-name {
    font-style: italic;
}

.add-new-row-button {
    margin-left: 10px;
}

.header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.table_wrapper {
    overflow: auto;
    max-width: 100%;
}

.v-input--is-disabled {
    opacity: 0.4;
}

.lock-icon {
    color: #CCC;
}

.status-chips {
    font-weight: bold;
}

.sortable-field {
    cursor: pointer;
}

.filter-button {
    width: 90px;
}

.clear-filter {
    min-width: 40px !important;
    width: 40px;
}

.filter-options {
    width: 170px;
}

input[readonly] {
    font-style: italic;
    color: #777;
}

tbody tr:hover {
    background-color: transparent !important;
}

/* 
Make table headers sticky
*/

/* Targets main 6 stick headers */
th.header:nth-child(-n+6) {
    position: sticky;
    z-index: 99;
    top: 0;
}

/* Targets all other top row header cells */
th:nth-child(n+7):not(.subheader) {
    position: sticky;
    z-index: 90;
    top: 0;
}

/* Targets all subheader cells */
th.subheader {
    position: sticky;
    z-index: 90;
    top: 35px;
}

.edit-mode th.header:nth-child(-n+6),
.edit-mode th.subheader,
.edit-mode th:nth-child(n+7):not(.subheader) {
    background-color: var(--v-primary-base);
}

.read-mode th.header:nth-child(-n+6),
.read-mode th.subheader,
.read-mode th:nth-child(n+7):not(.subheader) {
    background-color: #D1D1D1;
}

/* Targets the first 5 columns of the body of table */
td:nth-child(-n+6) {
    position: sticky;
    background-color: #FFF; /* Ensure the background isn't transparent */
    z-index: 10; /* Ensure sticky columns appear above other cells */
}

.grouped-row-child td {
    background-color: #F9F9F9;
}

/* Set the left position for each sticky column */
th:nth-child(1),
td:nth-child(1) {
    left: 0;
}

th:nth-child(2),
td:nth-child(2) {
    left: 50px;
}

th:nth-child(3),
td:nth-child(3) {
    left: 100px;
}

th:nth-child(4),
td:nth-child(4) {
    left: 250px;
}

.screen-l th:nth-child(4),
.screen-l td:nth-child(4),
.screen-x th:nth-child(4),
.screen-x td:nth-child(4) {
    left: 220px;
}

th:nth-child(5),
td:nth-child(5) {
    left: 400px;
}

.screen-l th:nth-child(5),
.screen-l td:nth-child(5),
.screen-x th:nth-child(5),
.screen-x td:nth-child(5) {
    left: 340px;
}

th:nth-child(6),
td:nth-child(6) {
    left: 550px;
}

.screen-l th:nth-child(6),
.screen-l td:nth-child(6),
.screen-x th:nth-child(6),
.screen-x td:nth-child(6) {
    left: 460px;
}

</style>

/* Multi-sort menu spacing tweaks */
.multi-sort-row {
    gap: 8px;
}
.multi-sort-select .v-input__control {
    min-height: 40px;
}
.multi-sort-select-menu .v-list-item {
    min-height: 40px;
}
